<template>
  <Dialog :common-dialog="productDialog" :dialog-width="dialog_width">
    <template v-slot:title>
      <v-layout>
        <v-flex>
          <span class="text-capitalize font-size-20"
            >Add SKILLS , LICENCE &amp; CERTS</span
          >
        </v-flex>
      </v-layout>
    </template>
    <template v-slot:body>
      <div class="px-5 py-2">
        <div
          v-if="skillCertItemAlpha && skillCertItemAlpha.length"
          class="d-flex mb-2"
          style="overflow-x: scroll"
        ></div>
        <div
          v-if="skillCertItemCategory && skillCertItemCategory.length"
          class="d-flex mb-2"
          style="overflow-x: scroll"
        >
          <div
            style="position: relative"
            v-for="(cat, index) in skillCertItemCategory"
            :key="`category-${index}`"
            class="custom-border-right"
          >
            <v-btn
              color="cyan white--text custom-bold-button"
              depressed
              tile
              :disabled="pageLoading"
              :text="category == cat.value"
              v-on:click="filter_cat(cat.value)"
            >
              {{ cat.label }}
            </v-btn>
          </div>
        </div>

        <div class="d-flex mb-2">
          <div class="d-flex">
            <v-text-field
              v-model="search"
              class="line-item-header-text px-0 v-slot-m-none"
              placeholder="Search..."
              dense
              filled
              solo
              :disabled="pageLoading"
              clearable
              v-on:click:clear="clearFilter('search')"
              flat
              color="cyan"
              style="width: 300px"
              v-on:keyup.enter="getCarts()"
            />
            <v-btn
              style="height: 32px !important"
              class="custom-bold-button ml-2"
              depressed
              :disabled="pageLoading"
              v-on:click="getCarts()"
              color="cyan white--text"
              ><v-icon>mdi-magnify</v-icon></v-btn
            >
            <v-btn
              style="height: 32px !important"
              class="custom-bold-button ml-2"
              depressed
              :disabled="pageLoading"
              v-on:click="getCarts()"
              color="cyan white--text"
              ><v-icon>mdi-reload</v-icon></v-btn
            >
          </div>
          <v-spacer></v-spacer>
          <div class="text-end pl-3">
            <v-autocomplete
              dense
              filled
              color="cyan"
              item-color="cyan"
              :items="categoryList"
              placeholder="Category"
              solo
              flat
              item-text="text"
              item-value="text"
              class="width-100"
              clearable
              v-on:click:clear="clearFilter('category')"
              v-on:change="getCarts"
              v-model.trim="category"
            >
            </v-autocomplete>
          </div>
        </div>

        <div>
          <div class="d-flex grey lighten-4 certis-table-header">
            <div
              class="font-weight-600 py-2 text-center d-flex justify-center"
              style="width: 5%"
            >
              <v-checkbox
                v-on:change="update_all_line_item($event)"
                :input-value="allVisibleItemsSelected"
                :indeterminate="someVisibleItemsSelected"
                hide-details
                :disabled="pageLoading"
                class="my-0 py-0 px-0 mx-0 dense-checkbox justify-center"
                color="cyan"
              />
            </div>
            <div
              class="color-custom-blue py-2 font-weight-700 text-left text-capitalize"
              style="width: 15%"
            >
              Color
            </div>
            <div
              class="color-custom-blue py-2 font-weight-700"
              style="width: 40%"
            >
              Name
            </div>
            <div
              class="color-custom-blue py-2 font-weight-700"
              style="width: 40%"
            >
              Type
            </div>
          </div>
          <div style="overflow-y: scroll; max-height: calc(100vh - 360px)">
            <table width="100%" class="custom-table border-collapse">
              <!-- <thead class="grey lighten-4">
                <tr>
                  <th class="py-2 text-center" style="width: 5%">
                    <v-checkbox
                      v-on:change="update_all_line_item($event)"
                      hide-details
                      :disabled="pageLoading"
                      class="my-0 py-0 px-0 mx-0 dense-checkbox justify-center"
                      color="cyan"
                    />
                  </th>
                  <th
                    class="color-custom-blue py-2 font-weight-700 text-left text-capitalize"
                    style="width: 15%"
                  >
                    Color
                  </th>
                  <th
                    class="color-custom-blue py-2 font-weight-700 text-left"
                    style="width: 40%"
                  >
                    Name
                  </th>
                  <th
                    class="color-custom-blue py-2 font-weight-700 text-left"
                    style="width: 40%"
                  >
                    Type
                  </th>
                </tr>
              </thead> -->
              <tbody v-if="skillCertItem && skillCertItem.length > 0">
                <tr
                  v-for="(row, index) in skillCertItem"
                  :key="index"
                  class="border-bottom alternate-listing-row"
                >
                  <td class="py-2 text-center" style="width: 5%">
                    <v-checkbox
                      :input-value="isSelected(row)"
                      @change="toggleSelection(row)"
                      hide-details
                      class="my-0 py-0 px-0 mx-0 dense-checkbox justify-center"
                      color="cyan"
                    />
                  </td>
                  <td class="py-2 text-left" style="width: 15%">
                    <v-chip
                      small
                      :color="row.color ? row.color : 'cyan'"
                      label
                      style="height: 18px; min-width: 26px"
                    ></v-chip>
                  </td>
                  <td class="py-2 text-left" style="width: 40%">
                    <div class="text-capitalize font-weight-500 font-size-16">
                      {{ row.name }}
                    </div>
                  </td>
                  <td class="py-2 text-left" style="width: 40%">
                    <v-chip
                      small
                      outlined
                      color="cyan"
                      class="text-capitalize font-weight-600"
                    >
                      {{ row.type }}
                    </v-chip>
                  </td>
                </tr>
              </tbody>
              <tbody v-else>
                <tr>
                  <td colspan="4" class="pa-6 text-center">
                    <img
                      :src="$assetURL('media/error/empty.png')"
                      class="row-not-found-image mb-2"
                      style="max-width: 120px"
                    />
                    <p class="m-0 text-muted font-weight-500 font-size-16">
                      Uhh... There are no item at the moment.
                    </p>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </template>
    <template v-slot:action>
      <v-flex class="text-right">
        <v-btn
          style="height: 32px !important"
          class="custom-bold-button mr-2"
          depressed
          :disabled="pageLoading"
          color="cyan white--text"
          v-on:click="save_Cert_item()"
          >Save</v-btn
        >
        <v-btn
          style="height: 32px !important"
          class="custom-bold-button"
          depressed
          :disabled="pageLoading"
          v-on:click="$emit('close', true)"
          >Close</v-btn
        >
      </v-flex>
    </template>
  </Dialog>
</template>
<script>
// import { mapGetters } from "vuex";
import { ErrorEventBus } from "@/core/lib/message.lib";
import Dialog from "@/view/pages/partials/Dialog.vue";
import { QUERY } from "../../core/services/store/request.module";

export default {
  name: "Add-skill",
  props: {
    productType: {
      type: String,
      default: null,
    },
    productDialog: {
      type: Boolean,
      default: false,
    },
    moduleType: {
      type: Number,
      default: 0,
    },
    relatedId: {
      type: Number,
      default: 0,
    },
    isType: {
      type: Number,
      default: 0,
    },
    updatedData: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data() {
    return {
      selectedItems: [],

      skillCertItemAlpha: null,
      pageLoading: false,
      search: null,
      category: null,
      categoryList: [
        { text: "Skill" },
        { text: "Certificate" },
        { text: "License" },
      ],
      skillCertItem: [],
      skillCertItemCategory: [],
    };
  },
  watch: {
    // productDialog(param) {
    //   if (param) {
    //     this.getCarts();
    //   }
    // },
    productDialog(param) {
      if (param) {
        // copy saved data into temp state ONCE
        this.selectedItems = this.updatedData
          ? JSON.parse(JSON.stringify(this.updatedData))
          : [];

        this.getCarts();
      }
    },
  },
  components: {
    Dialog,
  },
  methods: {
    isSelected(row) {
      return this.selectedItems.some(
        (item) => item.id === row.id && item.type === row.type
      );
    },

    toggleSelection(row) {
      const index = this.selectedItems.findIndex(
        (item) => item.id === row.id && item.type === row.type
      );

      if (index === -1) {
        this.selectedItems.push(row); // ✅ add
      } else {
        this.selectedItems.splice(index, 1); // ✅ remove
      }
    },
    update_all_line_item(status) {
      if (status) {
        this.skillCertItem.forEach((item) => {
          if (!this.isSelected(item)) {
            this.selectedItems.push(item);
          }
        });
        return;
      }

      this.selectedItems = this.selectedItems.filter((selected) => {
        return !this.skillCertItem.some(
          (item) => item.id === selected.id && item.type === selected.type
        );
      });
    },

    // save_Cert_item() {
    //   let selected_carts = [];

    //   let status = false;
    //   for (let item of this.skillCertItem) {
    //     if (item.status) {
    //       status = true;
    //       selected_carts.push(item);
    //     }
    //   }

    //   if (!status) {
    //     ErrorEventBus.$emit("update:error", `Please select Skills.`);
    //     return false;
    //   }
    //   this.$emit("update-values", selected_carts);
    //   this.$emit("close", true);
    // },
    save_Cert_item() {
      if (!this.selectedItems.length) {
        ErrorEventBus.$emit("update:error", `Please select Skills.`);
        return;
      }

      this.$emit("update-values", this.selectedItems);
      this.$emit("close", true);
    },
    getCarts() {
      const _this = this;
      _this.pageLoading = true;

      _this.$store
        .dispatch(QUERY, {
          url: "all-carts",
          data: {
            type: this.category,
            search: this.search,
          },
        })
        .then(({ data }) => {
          // ✅ KEEP previously selected items checked
          this.skillCertItem = data.map((item) => {
            return {
              ...item,
              status: this.selectedItems
                ? this.selectedItems.some(
                    (s) => s.id === item.id && s.type === item.type
                  )
                : false,
            };
          });
        })
        .catch((error) => {
          _this.logError(error);
        })
        .finally(() => {
          _this.pageLoading = false;
        });
    },

    // getCarts() {
    //   const _this = this;
    //   _this.pageLoading = true;
    //   _this.$store
    //     .dispatch(QUERY, {
    //       url: "all-carts",
    //       data: {
    //         type: this.category,
    //         search: this.search,
    //       },
    //     })
    //     .then(({ data }) => {
    //       this.skillCertItem = data;
    //       if (this.updatedData && this.updatedData.length > 0) {
    //         for (let i = 0; i < this.updatedData.length; i++) {
    //           for (let j = 0; j < this.skillCertItem.length; j++) {
    //             if (
    //               this.updatedData[i].id === this.skillCertItem[j].id &&
    //               this.updatedData[i].type === this.skillCertItem[j].type
    //             ) {
    //               this.skillCertItem[j].status = true;
    //               break; // Assuming each id is unique, exit inner loop once match is found
    //             }
    //           }
    //         }
    //       }
    //     })
    //     .catch((error) => {
    //       _this.logError(error);
    //     })
    //     .finally(() => {
    //       _this.pageLoading = false;
    //     });
    // },
    clearFilter(type) {
      if (type == "search") {
        this.search = null;
      }
      if (type == "category") {
        this.category = null;
      }

      this.getCarts();
    },
  },
  mounted() {},
  computed: {
    allVisibleItemsSelected() {
      return (
        this.skillCertItem.length > 0 &&
        this.skillCertItem.every((item) => this.isSelected(item))
      );
    },
    someVisibleItemsSelected() {
      return (
        !this.allVisibleItemsSelected &&
        this.skillCertItem.some((item) => this.isSelected(item))
      );
    },
    dialog_width() {
      return this.lodash.toSafeInteger((document.body.clientWidth / 100) * 50);
    },
  },
};
</script>
<style scoped>
.certis-table-header > :first-child {
  position: relative;
  inset-inline-start: -4px;
}

.certis-table-header > :not(:first-child) {
  position: relative;
  inset-inline-start: 8px;
}
</style>
